import instance from "./Request";

export const getCategories = async () => {
  const request = await instance();
  const data = await request.post("/categories").catch((error) => {
    return {
      error,
    };
  });

  return data;
};

export const updateCategoryStatus = async (payload) => {
  const request = await instance();
  const data = await request.post("/category/status/", payload).catch((error) => {
    return {
      error,
    };
  });

  return data;
};

export const updateCategory = async (payload) => {
  const request = await instance(true);
  const data = await request.post("/category/update", payload).catch((error) => {
    return {
      error,
    };
  });

  return data;
};
